export interface TradeSymbol {
    id?: string;
    trading_platform?: {
        id?: string;
        value_int?: number;
        value_string?: string;
    };
    origin_time?: Date;
    bid?: number;
    ask?: any;
    low?: any;
    high?: any;
    direction?: any;
    digits?: any;
    spread?: any;
    origin_modify_time?: Date;
}
